import React, { useState, useEffect } from "react";
import { FaLinkedinIn } from "react-icons/fa";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import GetInTouch from "./GetInTouch"; 

const Navbar = ({  refs }) => {
  const { homeRef, aboutRef, servicesRef, contactRef } = refs;
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false); 

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setShowNavbar(currentScrollY < lastScrollY || currentScrollY < 5);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  };


  return (
    <>
      {/* Navbar */}
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-transform duration-500 ${
          showNavbar
            ? "translate-y-0"
            : "-translate-y-full bg-gradient-to-b from-orange-500 to-transparent shadow-md"
        }`}
      >
        <div className="flex h-20 lg:h-32 w-full">
          {/* Left 70% */}
          <div className="w-full lg:w-[70%] bg-white flex justify-between items-center px-4 lg:px-6 py-3 lg:py-4">
            <div className="flex items-center gap-3 lg:gap-5">
              <img src="/Block Logo.png" alt="Logo" className="w-24 lg:w-36" />
              <div>
                {/* <h1 className="text-2xl lg:text-3xl font-bold text-[#0D1B39]">Okac</h1> */}
                {/* <p className="text-sm lg:text-base text-orange-600 -mt-1">Repairing Services</p> */}
              </div>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-6 text-[#0D1B39] font-medium text-sm mr-32">
            <button onClick={() => scrollToSection(homeRef)} className="hover:text-orange-500" >Home <span className="text-lg"></span></button>
            <button onClick={() => scrollToSection(aboutRef)} className="hover:text-orange-500" >About</button>
            <button onClick={() => scrollToSection(servicesRef)} className="hover:text-orange-500" >Services <span className="text-lg"></span></button>
            {/* <a className="hover:text-orange-500" href="https://arkdin-nextjs.vercel.app/home2">Pages <span className="text-lg">+</span></a> */}
            {/* <a className="hover:text-orange-500" href="https://arkdin-nextjs.vercel.app/home2">Blog <span className="text-lg">+</span></a> */}
            <button onClick={() => scrollToSection(contactRef)} className="hover:text-orange-500" >Contact</button>
          </nav>

            {/* Mobile Menu Icon */}
            <button
              className="lg:hidden text-3xl text-orange-600"
              onClick={toggleMobileMenu}
            >
              {mobileMenuOpen ? <HiX /> : <HiMenuAlt3 />}
            </button>
          </div>

          {/* Right 30% */}
          <div className="hidden lg:flex w-[30%] bg-orange-600 justify-center items-center gap-4 text-white px-6">
            <div className="flex gap-4 text-white">
              {/* <FaTwitter /> */}
              <FaLinkedinIn />
              {/* <FaBehance /> */}
            </div>
            <button
              onClick={openModal} // ✅ open modal on click
              className="bg-white text-orange-500 font-semibold px-6 py-3 rounded-md ml-2 hover:bg-blue-950 hover:text-white"
            >
              REQUEST A QUOTE
            </button>
          </div>
        </div>

        {/* Mobile Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="bg-white shadow-md px-4 py-4 lg:hidden">
            <nav className="flex flex-col gap-4 text-[#0D1B39] font-medium text-sm">
            <button className="hover:text-orange-500" >Home</button>
            <button className="hover:text-orange-500" >About</button>
            <button className="hover:text-orange-500" >Services</button>
            {/* <a className="hover:text-orange-500" href="https://arkdin-nextjs.vercel.app/home2">Pages</a> */}
            {/* <a className="hover:text-orange-500" href="https://arkdin-nextjs.vercel.app/home2">Blog</a> */}
            <button className="hover:text-orange-500" >Contact</button>
          </nav>
            <div className="mt-4 flex items-center justify-between">
              <div className="flex gap-4 text-orange-600 text-lg">
                {/* <FaTwitter /> */}
                <FaLinkedinIn />
                {/* <FaBehance /> */}
              </div>
              <button
                onClick={openModal} // ✅ open modal in mobile also
                className="bg-orange-600 text-white font-semibold px-4 py-2 rounded-md"
              >
                REQUEST A QUOTE
              </button>
            </div>
          </div>
        )}
      </header>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
          <div className="bg-white w-full max-w-3xl  rounded-lg relative overflow-y-auto max-h-[90vh]">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-2xl text-orange-500 hover:text-red-500"
            >
              <HiX />
            </button>
            <GetInTouch showModal={showModal} />
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
